import * as angular from 'angular';
import moment from 'moment';

// @ts-ignore
function Config($logProvider, $httpProvider, $provide, $mdDateLocaleProvider, localStorageServiceProvider,
  // @ts-ignore
  loggerConfig, usSpinnerConfigProvider, toastrConfig, ngDialogProvider, ENV, PIMS_FONTS) {
  'ngInject';

    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', PIMS_FONTS);
    // @ts-ignore
  document.querySelector('head').appendChild(link);

    /* Enable/disable logs based on current environment */
    loggerConfig.enabled = ENV !== 'production' && ENV !== 'test';
    $logProvider.debugEnabled(loggerConfig.enabled);

    Object.assign(toastrConfig, {
      allowHtml: true,
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
    });

  /* Prefix our local storage keys with our environment */
  localStorageServiceProvider.setPrefix(`${ENV}.pims`);

  /* Attach our custom HTTP Incerceptor. See src/app/common/services/http.service.js */
  $httpProvider.interceptors.push('HttpInterceptor');

  $mdDateLocaleProvider.formatDate = (date: any) => moment(date).format('DD-MMM-yy');

  /* Gray spinner */
  usSpinnerConfigProvider.setDefaults({ color: 'grey' });

  moment.updateLocale('en', {
    relativeTime: {
      future: 'in %s',
      past: '%s',
      s: 'Now',
      m: '1m',
      mm: '%dm',
      h: '1h',
      hh: '%dh',
      d: '1d',
      dd: '%dd',
      M: 'A month',
      MM: '%d months',
      y: '1 year',
      yy: '%d years',
    },
  });

  /* Mount our custom tabset template */
  $provide.decorator('uibTabsetDirective', ['$delegate', ($delegate: any[]) => {
    const directive = $delegate[0];
    directive.templateUrl = 'app/components/tabs/sticky-tabs.tpl.html';
    return $delegate;
  }]);
};
Config.$inject = ["$logProvider", "$httpProvider", "$provide", "$mdDateLocaleProvider", "localStorageServiceProvider", "loggerConfig", "usSpinnerConfigProvider", "toastrConfig", "ngDialogProvider", "ENV", "PIMS_FONTS"];
angular.module('pims').config(Config);
